import {Component, OnInit} from '@angular/core';
import {BaseDashComponent} from 'src/cad/dashboard/views/content/components/base-dash.component';
import {ApiHelper} from 'cad/common/services/api/api-helper';
import {RouterService} from 'cad/core/services/router/router.service';
import {ActivatedRoute} from '@angular/router';
import {UserPreferenceService} from 'cad/common/services/preferences/user-preferences';
import {
  NominationMatrixPinnedContractApi
} from 'cad/common/services/api/nomination/nomination-matrix/pinned-contract/pinned-contract';
import {of} from 'rxjs';
import {UiGridApi} from 'src/ag-grid-wrapper';
import {GridReadyEvent, RowClickedEvent} from '@ag-grid-community/core';
import {UserModelService} from 'cad/common/services/user/user-model-service';
import {map, shareReplay} from 'rxjs/operators';

@Component({
  selector: 'nom-dash',
  templateUrl: './nom-dash.component.html',
})
export class NomDashComponent extends BaseDashComponent implements OnInit {
  public name: string = 'nom';
  private gridApi: UiGridApi;

  constructor(public apiHelper: ApiHelper,
              public routerService: RouterService,
              public activatedRoute: ActivatedRoute,
              public userPreferenceService: UserPreferenceService,
              public nominationMatrixPinnedContractApi: NominationMatrixPinnedContractApi,
              private userModelService: UserModelService,
              ) {
    super(apiHelper, routerService, activatedRoute, userPreferenceService);
  }

  ngOnInit(): void {
    if (this.userDetails?.userId) {
      this.trimSize = 5;
      this.showLatest = true;
      this.itemData$ = this.nominationMatrixPinnedContractApi.filter()
        .pipe(
          map((data) => this.trimData(data))
        );
    } else {
      this.itemData$ = of(null);
    }
    super.ngOnInit();
  }

  public getEmptyHeadline(): string {
    return 'No Pinned Nominations';
  }
  public getDefaultHeadline(): string {
    return 'Pinned Nominations';
  }
  public getName(): string {
    return this.name;
  }

  public onGridReady($event: GridReadyEvent): void {
    this.gridApi = $event.api;
  }

  public onRowClicked($event: RowClickedEvent): void {
    const data = {
      type: 'regular',
      assetNbr: this.userModelService.getCurrentAssetNbr(),
      contractId: $event.data.contractId,
      beginDate: dateUtil().getFormattedDate(dateUtil().getCurrentDateTime(), 'YYYY-MM-DD'),
      endDate: dateUtil().getFormattedDate(dateUtil().getCurrentDateTime(), 'YYYY-MM-DD')
    };
    this.routerService.navigateWithData({data}, [ `/nominations/nomination/nomination-matrix/${$event.data.contractId}` ]);
  }
}
